/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, isEmpty } from '../twd'
import { useCalculator, STEPS } from './use-calculator'

export const Header = () => {
    const {
        step, changeCusip, bondInfo, showCoupon, calcOutput, resetCalc
    } = useCalculator()

    const isShowBack = [
        STEPS.INIT,
        STEPS.INIT_LOADING,
        STEPS.INIT_ERROR,
        STEPS.CUSIP_INPUT,
        STEPS.CUSIP_ERROR,
        STEPS.CUSIP_LOADING,
    ].indexOf(step)<0

    return  <React.Fragment>
        <div className="row">
        <div className="col-md-2 col-xs-2">
        <div className="vertical-offset-md"></div>
            {isShowBack && <button
                className="close"
                style={{right:'unset'}}
                aria-label="close"
                type="button"
                onClick={() => {
                    const fn = step===STEPS.CALC_OUTPUT || step===STEPS.CALC_ERROR
                        ? resetCalc
                        : changeCusip
                    fn()
                }}>
                <i className="material-icons" aria-hidden="true" style={{color:'var(--primary-base-color)'}}>arrow_back</i>
            </button>}
        </div>
        <div className="col-md-8 col-xs-8 text-center">
            <h3 className="medium-header ">Price/yield calculator</h3>
        </div>
        <div className="col-md-2 col-xs-2">
            <div className="vertical-offset-md"></div>
            <button
                className="close"
                aria-label="close"
                data-name="calculator-modal-close-link"
                type="button"
                onClick={hideModal}>
                <i className="material-icons" aria-hidden="true" style={{color:'var(--primary-base-color)'}}>close</i>
            </button>
        </div>
        </div>


        {!isEmpty(bondInfo) && bondInfo.canCalc && showCoupon && isEmpty(calcOutput) && <div className="row">
        <div className="col-md-12 col-xs-12">
            <div
                className="universal-message universal-message-info universal-message-dismissible"
                role="alert">
            <div className="universal-message-content">
            <div className="universal-message-heading">
                    Enter a quantity in the calculator to review the estimated coupon payment schedule
                    from investing in this security at the current best offer price.
                    You can also edit the current best offer to perform custom calculations.
            </div>
            </div>
            </div>
        </div>
        </div>}
        </React.Fragment>

}



// WEBPACK FOOTER //
// ./src/calculator/header.js